export default __webpack_public_path__ + "static/seoImage-0690c51199c72b2749b1122bf588edc9.png";